import { Spinner } from "@heroui/react";
import { type Address, erc20Abi } from "viem";
import { useReadContract } from "wagmi";

export function EthTokenDetails({ tokenAddress }: { tokenAddress: Address }) {
  const nameQuery = useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: "name",
  });

  const symbolQuery = useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: "symbol",
  });

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-center justify-between">
        <div className="text-[#ADC0D0] text-sm">Token Name</div>
        <div className="text-sm font-semibold">{nameQuery.status === "success" ? nameQuery.data : <Spinner />}</div>
      </div>
      <div className="flex items-center justify-between">
        <div className="text-[#ADC0D0] text-sm">Token Symbol</div>
        <div className="text-sm font-semibold">{symbolQuery.status === "success" ? symbolQuery.data : <Spinner />}</div>
      </div>
    </div>
  );
}
